export default "__VITE_ASSET__37qdHuUD__"